<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--9">
          <div class="row">
            <div class="col-xl-12">
              <div class="card shadow">
                <div class="card-header bg-transparent">
                  <div>
                    <div>
                      <h3>Crear un nuevo Cliente</h3>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div v-if="nuevosClientes">
                    <div v-if="nuevosClientes.length > 0">
                      <label class="form-control-label">Buscar un cliente Nuevo</label>
                      <multiselect
                        v-model="nuevoClienteSelected"
                        :options="nuevosClientes"
                        placeholder="Buscar por razón social"
                        label="f_razonsocial"
                        track-by="f_rfc"
                        @select="dispatchActionSelectNuevo"
                        class="mb-3">
                      </multiselect>
                    </div>
                    <center v-else>
                      <h4 class="text-muted p-4">No hay clientes nuevos para seleccionar</h4>
                    </center>                          
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Datos Fiscales</h4>
                </div>
                <div class="card-body">
                  <h5 v-if="f_grupoComercial">Grupo Comercial: {{f_grupoComercial}}</h5>
                  <h5> {{ f_enchapadora ? "Si tiene enchapadora" : "No tiene enchapadora"}} </h5>
                  <h5 v-if="f_regimenfiscal">Régimen Fiscal: {{f_regimenfiscal.Code +" - "+ f_regimenfiscal.Name}}</h5>
                  <h5 v-if="f_const_fiscal_url"><a :href="f_const_fiscal_url" target="_blank">Ver Constancia Fiscal</a></h5>
                  <hr>
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Razón Social"
                                  v-model="f_razonsocial"
                                  placeholder="Razón Social de la Empresa"
                                  inputClasses="input-group-alternative"    
                                  required>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="RFC"
                                  v-model="f_rfc"
                                  placeholder="RFC"
                                  inputClasses="input-group-alternative"
                                  required>
                      </base-input>
                    </div>
                    <div v-if="f_extranjero" class="col-lg-6">
                      <base-input label="Tax ID"
                                  v-model="f_taxid"
                                  placeholder="Tax ID"
                                  inputClasses="input-group-alternative"
                                  required>
                      </base-input> 
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Calle"
                                  v-model="f_calle"
                                  placeholder="Calle" 
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="No. Exterior" 
                                  v-model="f_noexterior"
                                  placeholder="No. Ext."
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="No. Interior"
                                  v-model="f_nointerior"
                                  placeholder="No. Int."
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Colonia"
                                  v-model="f_colonia"
                                  placeholder="Colonia"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="Código Postal"
                                  v-model="f_codigopostal"
                                  placeholder="Código Postal"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="Teléfono"
                                  v-model="f_telefono"
                                  placeholder="10 dígitos"
                                  :maxlength="10"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">Estado</label>
                      <multiselect
                        v-if="!f_extranjero"
                        v-model="f_estado"
                        :options="estados"
                        placeholder="Estado"
                        label="name"
                        track-by="code"
                        class="mb-3">
                      </multiselect>
                      <base-input
                        v-else
                        v-model="f_estado"
                        placeholder="Estado"
                        inputClasses="input-group-alternative"
                        class="mb-3"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Municipio"
                                  v-model="f_municipio"
                                  placeholder="Municipio"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div v-if="f_extranjero" class="col-lg-6">
                      <base-input label="País"
                                  v-model="f_pais"
                                  placeholder="País"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>

                    <div class="col-lg-6">
                      <base-input label="Email para envio de facturas"
                                  v-model="f_email"
                                  placeholder="Email"
                                  type="email"
                                  inputClasses="input-group-alternative"
                                  required>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Página Web"
                                  v-model="f_paginaweb"
                                  placeholder="Página Web"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Datos de contacto</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                      <div class="col-lg-4">
                        <base-input label="Primer Nombre"
                                    v-model="fc_nombre"
                                    placeholder="Primer Nombre"
                                    inputClasses="input-group-alternative">
                        </base-input>
                      </div>
                      <div class="col-lg-4">
                        <base-input label="Segundo Nombre"
                                    v-model="fc_nombre2"
                                    placeholder="Segundo Nombre"
                                    inputClasses="input-group-alternative">
                        </base-input>
                      </div>
                      <div class="col-lg-4">
                        <base-input label="Apellidos"
                                    v-model="fc_apellidos"
                                    placeholder="Apellidos"
                                    inputClasses="input-group-alternative">
                        </base-input>
                      </div>
                      <div class="col-lg-6">
                        <base-input label="Puesto"
                                    v-model="fc_puesto"
                                    placeholder="Puesto"
                                    inputClasses="input-group-alternative">
                        </base-input>
                      </div>
                      <div class="col-lg-6">
                        <base-input label="Email"
                                    v-model="fc_email"
                                    placeholder="Email"
                                    inputClasses="input-group-alternative">
                        </base-input>
                      </div>
                    </div>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Número de celular para ingresar a la plataforma</h4>
                </div>
                <div class="card-body">
                  <base-input label="Número de celular"
                              v-model="c_telefono"
                              placeholder="10 dígitos"
                              :maxlength="10" 
                              inputClasses="input-group-alternative">
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="card shadow my-4">
                <div class="card-header d-flex justify-content-between">
                  <h4>Domicilio de Entrega</h4>
                  <base-checkbox v-model="f_mismaDireccion" :change="checkSameAddress()" >
                    Utilizar el mismo que facturación
                  </base-checkbox>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Título del Domicilio"
                                  v-model="fe_titulo"
                                  placeholder="Título del Domicilio"
                                  :disabled="f_mismaDireccion"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Calle"
                                  v-model="fe_calle"
                                  placeholder="Calle"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="No. Exterior"
                                  v-model="fe_noexterior"
                                  placeholder="No. Ext."
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-3 col-6">
                      <base-input label="No.Interior"
                                  v-model="fe_nointerior"
                                  placeholder="No.Int."
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Colonia"
                                  v-model="fe_colonia"
                                  placeholder="Colonia"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Código Postal"
                                  v-model="fe_codigopostal"
                                  placeholder="Código Postal"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">Estado</label>
                      <multiselect
                        v-if="!f_extranjero"
                        v-model="fe_estado"
                        :options="estados"
                        placeholder="Estado"
                        label="name"
                        track-by="code"
                        class="mb-3">
                      </multiselect>
                      <base-input
                        v-else
                        v-model="fe_estado"
                        placeholder="Estado"
                        inputClasses="input-group-alternative"
                        class="mb-3"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Municipio"
                                  v-model="fe_municipio"
                                  placeholder="Municipio"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                    <div v-if="f_extranjero" class="col-lg-6">
                      <base-input label="País"
                                  v-model="fe_pais"
                                  placeholder="País"
                                  inputClasses="input-group-alternative">
                      </base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Ramo *</h4>
                </div>
                <div class="card-body">
                  <multiselect
                    v-model="f_ramo"
                    :options="ramo"
                    placeholder="Selecciona el Ramo"
                    label="name"
                    track-by="code"
                    class="mb-3">
                  </multiselect>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Tipo de cliente y tipo de uso*</h4>
                </div>
                <div class="card-body">
                  <div class="col-lg-12"> 
                      <label class="form-control-label">Tipo de cliente *</label>
                  <multiselect
                    v-model="f_customer_segment"
                    :options="customer_segments"
                    placeholder="Tipo de cliente"
                    label="name"
                    track-by="code"
                    class="mb-3">
                  </multiselect>
                  </div>
                  <div class="col-lg-12"> 
                      <label class="form-control-label">Tipo de uso</label>
                  <multiselect
                    v-model="f_usage_type"
                    :options="usage_types"
                    placeholder="Tipo de uso"
                    label="name"
                    track-by="code"
                    class="mb-3">
                  </multiselect>
                  </div>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Condiciones de Pago</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-12"> 
                      <label class="form-control-label">Uso CFDI *</label>
                      <multiselect
                      v-model="f_usocfdi"
                      :options="cfdi"
                      placeholder="CFDI"
                      label="name"
                      track-by="code"
                      class="mb-3">
                    </multiselect>
                    </div>
                    <div class="col-lg-6"> 
                      <label class="form-control-label">Moneda</label>
                      <multiselect
                      v-model="f_moneda"
                      :options="moneda"
                      placeholder="Moneda"
                      class="mb-3">
                    </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card shadow my-4">
                <div class="card-header">
                  <h4>Vendedor/a</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6"> 
                      <label class="form-control-label">Vendedor/a *</label>
                      <multiselect
                        v-model="f_vendedor"
                        :options="salesPersons"
                        placeholder="Vendedor/a"
                        label="SalesEmployeeName"
                        track-by="SalesEmployeeCode"
                        class="mb-3"
                        :loading="!salesPersons.length > 0"
                        :disabled="!salesPersons.length > 0">
                      </multiselect>
                    </div>
                    <div class="col-lg-6"> 
                      <label class="form-control-label">CEDIS *</label>
                      <multiselect
                        v-model="f_cedis"
                        :options="cedis"
                        placeholder="CEDIS"
                        class="mb-3">
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-xl-12">
              <div class="card shadow">
                <div class="card-header">
                  <h3>Confirmación</h3>
                </div>
                <div class="card-body">
                  <div v-if="!creating" class="d-flex flex-column flex-xl-row justify-content-between align-content-center">
                    <base-checkbox v-model="f_validacion" class="mb-xl-0 mb-4">
                      He verificado detenidamente que los datos de este cliente sean correctos. 
                    </base-checkbox>
                    <base-button 
                      @click="crearCliente()" 
                      icon="fa fa-check"
                      :disabled="!f_validacion || 
                      creating || 
                      !f_ramo ||
                      !f_cedis ||
                      !f_vendedor ||
                      !f_usocfdi ||
                      !f_rfc || 
                      !f_razonsocial || 
                      !f_email ||
                      !f_customer_segment">
                        Guardar Nuevo Cliente
                    </base-button>                        
                  </div>
                  <base-loader v-if="creating" text="Guardando cliente. Por favor espere."></base-loader>
                </div>
              </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>

  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import Multiselect from "vue-multiselect";
  import { getAuth, getIdToken } from "firebase/auth";
  import { getFirestore, collection, query, where, getDocs, deleteDoc } from "firebase/firestore";
  import BaseLoader from '../components/BaseLoader.vue';
  Vue.use(VueClipboard)
  export default {
    components:{
      Multiselect,
      BaseLoader
    },
    directives: {
      'b-tooltip': BTooltipDirective
    },
    created(){
      const auth = getAuth();
      this.user = auth.currentUser;
      getIdToken(auth.currentUser, true)
      .then((idToken) => {
        fetch('https://canplast.net:50000/api/v1/auth/verifyToken', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token: idToken })
        })
          .then(response => response.json())
          .then(responseJson => {
            localStorage.setItem('token-cpm', responseJson.token)
          })
          .catch(error => console.error(error));
      })
      .catch(error => console.log(error));
    },
    mounted(){
      fetch('https://canplast.net:50000/api/v1/sap/GET/SalesPersons',{
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':localStorage.getItem('token-cpm')
        }
      })
      .then((response) => response.json())
      .then((responseJson) => {
        this.salesPersons = responseJson.value
      })

      const db = getFirestore();
      const nuevosClientesRef = collection(db, "NuevosClientes");
      getDocs(nuevosClientesRef).then(querySnapshot => {
        if (querySnapshot.size > 0) {
          querySnapshot.forEach(docSnap => {
            this.nuevosClientes.push(docSnap.data());
          });
          console.log("Nuevos", this.nuevosClientes);
        }
      });
    },
    beforeMount(){
      const auth = getAuth();
      getIdToken(auth.currentUser, true)
        .then(idToken => {
          // Token obtenido (opcional: console.log(idToken))
        })
        .catch(error => alert(error));
      
    },
    data() {
      return {
        tableData: [],
        user:null,
        showLoader: true,
        cedis_backlog:'CUU',
        slitter: 'No',
        creating: false,
        f_extranjero: false,
        f_razonsocial:null,
        f_rfc:null,
        f_taxid:null,
        f_telefono:null,
        f_paginaweb:null,
        f_email:null,
        f_regimenfiscal: null,
        f_const_fiscal_url: null,
        f_moneda: null,
        f_usocfdi: null,
        f_metodopago:'METODO PAGO',
        f_cedis: null,
        salesPersons: [],
        f_vendedor: null,
        f_ramo: null,
        f_mismaDireccion: false,
        f_calle:null,
        f_noexterior: null,
        f_nointerior: null,
        f_codigopostal: null,
        f_estado: null, //Estado 1 (Datos Fiscales)
        f_municipio: null,
        f_colonia: null,
        f_pais: null,
        fe_titulo: null,
        fe_calle:null,
        fe_noexterior: null,
        fe_nointerior: null,
        fe_codigopostal: null,
        fe_estado: null, //Estado 2 (Domicilio de Entrega)
        fe_municipio: null,
        fe_colonia: null,
        fe_pais: null,
        fc_nombre:null,
        fc_nombre2: null,
        fc_apellidos: null,
        fc_puesto: null,
        fc_email: null,

        f_validacion: false,

        f_colonias:[],
        fe_colonias:[],

        c_telefono: null,
        nuevosClientes:[],
        nuevoClienteSelected: null,
        f_enchapadora: false,
        f_pertenezcoGrupo: false,
        f_grupoComercial: null,
        f_customer_segment: null,
        customer_segments:[
          {code: 'Premier', name: "Distribuidor Premium"},
          {code: 'Standard', name: "Distribuidor Estándar"},
          {code: 'Large', name: "Fabricante Grande"},
          {code: 'Undefined', name: "Fabricante No Definido"},
        ],
        f_usage_type: null,
        usage_types:[
          {code: 'Project', name: "Por Proyecto"},
          {code: 'Catalogue', name: "De Línea o Catálogo"},
          {code: 'Combined', name: "Combinado"},
        ],
        estados:[
          {code: 'AGS', name: "Aguascalientes",     extraCode:'AGU'},
          {code: 'BC' , name: "Baja California",    extraCode:'BCN'},
          {code: 'BCS', name: "Baja California Sur" },
          {code: 'CAM', name: "Campeche"            },
          {code: 'CHI', name: "Chihuahua",          extraCode:'CHH'},
          {code: 'CHS', name: "Chiapas",            extraCode:'CHP'},
          {code: 'CMX', name: "Ciudad de México",   extraCode:'DIF'},
          {code: 'COA', name: "Coahuila"            },
          {code: 'COL', name: "Colima"              },
          {code: 'DUR', name: "Durango"             },
          {code: 'GTO', name: "Guanajuato",         extraCode:'GUA'},
          {code: 'GRO', name: "Guerrero"            },
          {code: 'HID', name: "Hidalgo"             },
          {code: 'JAL', name: "Jalisco"             },
          {code: 'MCH', name: "Michoacán",          extraCode:'MIC'},
          {code: 'MEX', name: "Estado de México"    },
          {code: 'MOR', name: "Morelos"             },
          {code: 'NAY', name: "Nayarit"             },
          {code: 'NL' , name: "Nuevo León",         extraCode:'NLE'},
          {code: 'OAX', name: "Oaxaca"              },
          {code: 'PUE', name: "Puebla"              },
          {code: 'QR' , name: "Quintana Roo",       extraCode:'ROO'},
          {code: 'QUE', name: "Querétaro"           },
          {code: 'SIN', name: "Sinaloa"             },
          {code: 'SLP', name: "San Luis Potosí"     },
          {code: 'SON', name: "Sonora"              },
          {code: 'TAB', name: "Tabasco"             },
          {code: 'TAM', name: "Tamaulipas"          },
          {code: 'TLA', name: "Tlaxcala"            },
          {code: 'VER', name: "Veracruz"            },
          {code: 'YUC', name: "Yucatán"             },
          {code: 'ZAC', name: "Zacatecas"           },
        ],
        ramo:[
          {code:"-1", name: "Sin industria"},
          {code: "1", name: "Fabricante"},
          {code: "2", name: "Distribuidor"},
          {code: "3", name: "Maquinaria y H"},
          {code: "4", name: "Comunicaciones"},
        ],
        cfdi:[
          {code: 'G01',  name: "G01 - Adquisición de mercancias"},
          {code: 'G02',  name: "G02 - Devoluciones, descuentos o bonificaciones"},
          {code: 'G03',  name: "G03 - Gastos en general"},
          {code: 'I01',  name: "I01 - Construcciones"},
          {code: 'I02',  name: "I02 - Mobilario y equipo de oficina por inversiones"},
          {code: 'I03',  name: "I03 - Equipo de transporte"},
          {code: 'I04',  name: "I04 - Equipo de cómputo y accesorios"},
          {code: 'I05',  name: "I05 - Dados, troqueles, moldes, matrices y herramental"},
          {code: 'I06',  name: "I06 - Comunicaciones telefónicas"},
          {code: 'I07',  name: "I07 - Comunicaciones satelitales"},
          {code: 'D01',  name: "D01 - Honorarios médicos, dentales y gastos hospitalarios"},
          {code: 'D02',  name: "D02 - Gastos médicos por incapacidad o discapacidad"},
          {code: 'D03',  name: "D03 - Gastos funerales"},
          {code: 'D04',  name: "D04 - Donativos"},
          {code: 'D05',  name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)"},
          {code: 'D06',  name: "D06 - Aportaciones voluntarias al SAR"},
          {code: 'D07',  name: "D07 - Primas por seguros de gastos médicos"},
          {code: 'D08',  name: "D08 - Gastos de transportación escolar obligatoria"},
          {code: 'D09',  name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones"},
          {code: 'D10',  name: "D10 - Pagos por servicios educativos (colegiaturas)"},
          {code: 'S01',  name: "S01 - Sin efectos fiscales"},
        ],
        moneda:['MXP', 'USD', 'EUR'],
        cedis: ['CUU', 'MEX', 'GDL', 'QRO', 'MTY', 'MID', 'TIJ'],
      }
    },
    methods:{
      // buscarColonias(cp, entrega){
      //   if(cp && cp.length == 5){
      //     fetch('https://api.zippopotam.us/MX/'+cp,{
      //       method: 'GET'
      //     })
      //     .then((response) => response.json())
      //     .then((responseJson) => {
      //       if(!entrega)
      //         this.f_colonias = responseJson.places
      //       else
      //         this.fe_colonias = responseJson.places
      //     });
      //   }
      // },

      findState(code){
        let stateCode = this.estados.find(x => x.code === code || x.extraCode === code);
        return stateCode ? stateCode : null;
      },
      dispatchActionSelectNuevo(data){
        this.f_extranjero = data.f_extranjero
        this.f_taxid = data.f_taxid
        this.f_calle = data.f_calle
        this.f_cedis = data.f_cedis === 'CEDIS' ? null : data.f_cedis;
        this.f_codigopostal = data.f_codigopostal
        this.f_colonia = data.f_otracolonia ? data.f_otracolonia : data.f_colonia
        this.f_email = data.f_email
        this.f_estado = data.f_extranjero ? data.f_estado : this.findState(data.f_estado);  //Estado 1 (Datos Fiscales)
        this.f_moneda = data.f_moneda
        this.f_municipio = data.f_municipio
        this.f_noexterior = data.f_noexterior
        this.f_nointerior = data.f_nointerior
        this.f_pais = data.f_pais
        this.f_paginaweb = data.f_paginaweb
        this.f_ramo = data.f_ramo === 'RAMO' ? null : this.ramo.find(x => x.code === data.f_ramo);
        this.f_razonsocial = data.f_razonsocial
        this.f_rfc = data.f_rfc
        this.f_telefono = data.f_telefono
        this.f_usocfdi = data.f_usocfdi === 'USO CFDI' ? null : this.cfdi.find(x => x.code === data.f_usocfdi);
        this.f_vendedor = data.f_vendedor === 'VENDEDOR' ? null : this.salesPersons.find(x => x.SalesEmployeeCode === data.f_vendedor);
        this.fc_email = data.fc_email
        this.fc_nombre = data.fc_nombre
        this.fc_nombre2 = data.fc_nombre2
        this.fc_apellidos = data.fc_apellidos
        this.fc_puesto = data.fc_puesto
        this.fe_titulo = data.fe_titulo
        this.fe_calle = data.fe_calle
        this.fe_codigopostal = data.fe_codigopostal
        this.fe_colonia = data.e_otracolonia ? data.e_otracolonia : data.fe_colonia
        this.fe_estado = data.f_extranjero ? data.fe_estado : this.findState(data.fe_estado); // Estado 2 (Domicilio de entrega)
        this.fe_municipio = data.fe_municipio
        this.fe_noexterior = data.fe_noexterior
        this.fe_nointerior = data.fe_nointerior
        this.fe_pais = data.fe_pais
        this.c_telefono = data.c_telefono
        //this.f_vendedor = -1;
        this.f_grupoComercial = data.f_grupoComercial
        this.f_pertenezcoGrupo = data.f_pertenezcoGrupo
        this.f_enchapadora = data.f_enchapadora
        this.f_moneda = 'MXP';
        this.f_regimenfiscal = data.f_regimenfiscal;
        this.f_const_fiscal_url = data.f_const_fiscal_url;

      },
      crearCliente(){
        this.creating = true;
        var contactosArray = [];
        var FirstName = this.fc_nombre;
        if(this.fc_nombre2){
          FirstName = FirstName +' '+this.fc_nombre2
        }
        if(this.fc_apellidos){
          FirstName = FirstName + ' '+this.fc_apellidos
        }
        if(this.f_email != ''){
          contactosArray = [
            {
              "FirstName":FirstName,
              "Position":this.fc_puesto,
              "Name":this.fc_puesto,
              "E_Mail":this.fc_email,
              "U_TS_EnvioCorreo":"SI",
              "U_TS_EnvioPago":"SI"
            },
            {
              "Name":"Correo Envio Facturas/Pagos",
              "E_Mail":this.f_email,
              "U_TS_EnvioCorreo":"SI",
              "U_TS_EnvioPago":"SI"
            }
          ]
        }
        else{
          contactosArray = [
            {
              "FirstName":FirstName,
              "Position":this.fc_puesto,
              "Name":this.fc_puesto,
              "E_Mail":this.fc_email
            }
          ]
        }

        if(this.c_telefono){
          contactosArray.push({
            "Name":"Acceso a Plataforma",
            "Phone1":this.c_telefono,
          })
        }

        let Properties20 = 'tNO'
        if(this.f_enchapadora){
          Properties20 = 'tYES'
        }

        var jsonData = {
          "BusinessPartner":{
            "CardType": "cCustomer",
            "CardName": this.f_razonsocial,
            "FederalTaxID": this.f_rfc.toUpperCase(),
            "Industry":this.f_ramo.code, //CHECK
            "Phone1":this.f_telefono,
            "Website":this.f_paginaweb,
            "EmailAddress":this.f_email,
            "FreeText":"Registrado por "+this.user.displayName+" desde la Nueva Consola de Administración", 
            "U_B1SYS_MainUsage":this.f_usocfdi.code, //CHECK
            "U_TS_UsoSN":this.f_usocfdi.code,
            "U_CEDIS":this.f_cedis,
            "Currency":this.f_moneda,
            "SalesPersonCode":this.f_vendedor.SalesEmployeeCode, //CHECK
            "ContactEmployees": contactosArray,
            "Properties20":Properties20,
            "U_CustomerType": this.f_customer_segment.code,
            //"U_CustomerSegment": this.f_customer_segment.code,
            "U_UsageType": this.f_usage_type ? this.f_usage_type.code : null,
            "U_TS_RegFiscal":this.f_regimenfiscal.Code,
            "Priority": 1,
            "U_FiscalCertificateLink": !this.f_extranjero ? this.f_const_fiscal_url : null,
            "BPPaymentMethods":[
              {
                "PaymentMethodCode":"01"
              },
              {
                "PaymentMethodCode":"02"
              },
              {
                "PaymentMethodCode":"03"
              },
              {
                "PaymentMethodCode":"04"
              },
              {
                "PaymentMethodCode":"15"
              },
              {
                "PaymentMethodCode":"28"
              },
              {
                "PaymentMethodCode":"30"
              }
            ]
          }
        }
        if(this.f_extranjero){
          jsonData.BusinessPartner.UnifiedFederalTaxID = this.f_taxid
        }
        var addAddress = [{
          "AddressName": "Domicilio Fiscal",
          "AddressType": "bo_BillTo",
          "Street": this.f_calle,
          "ZipCode": this.f_codigopostal,
          "City": this.f_municipio,
          "State": this.f_estado.code,
          "BuildingFloorRoom": this.f_nointerior,
          "StreetNo":this.f_noexterior,
          ... this.f_extranjero ? { "Country": this.f_pais } : {}
        },
        {
          "AddressName": this.fe_titulo,
          "AddressType": "bo_ShipTo",
          "Street": this.fe_calle,
          "ZipCode": this.fe_codigopostal,
          "City": this.fe_municipio,
          "State": this.fe_estado.code,
          "BuildingFloorRoom": this.fe_nointerior,
          "StreetNo": this.fe_noexterior,
          ... this.f_extranjero ? { "Country": this.fe_pais, "TaxCode":"B0" } : {}
        }]

        if(this.fe_colonia === 'Otra'){
          //addAddress[1].Block = cliente.otracoloniaEntrega;
        }
        else{
          addAddress[1].Block = this.fe_colonia;
        }
        if(this.f_colonia === 'Otra'){
          //addAddress[0].Block = cliente.otracolonia;
        }
        else{
          addAddress[0].Block = this.f_colonia;
        }
        jsonData.BusinessPartner.BPAddresses = addAddress;
        jsonData.BusinessPartner.ShipToDefault = this.fe_titulo;


        jsonData.BusinessPartner.CardName = this.f_razonsocial.toUpperCase()

        console.log("NUEVO CLIENTE", jsonData)

        setTimeout(() => {

          axios('https://canplast.net:50000/api/v1/sap/POST/BusinessPartners', {
            method: 'POST',
            data: jsonData,
            headers: {
              'Content-Type': 'application/json',
              'x-access-token':localStorage.getItem('token-cpm')
            }
          })
          .then((result) => {
            console.log(result);
            if(!result.data.warn){
              if(result.data.CardCode){
                this.$swal.fire(result.data.CardCode+' registrado correctamente ', "", "success");
                const db = getFirestore();
                const nuevosClientesRef = collection(db, "NuevosClientes");
                const q = query(nuevosClientesRef, where("f_rfc", "==", this.f_rfc.toUpperCase()));
                getDocs(q).then((querySnapshot) => {
                  if (querySnapshot.size > 0) {
                    querySnapshot.forEach((docSnap) => {
                      deleteDoc(docSnap.ref);
                    });
                  }
                });
              }
              else{
                this.$swal.fire("Error", "Hubo un error al registrar este cliente", "error");
              }
              
            }
            else{
              this.$swal.fire("Error", result.data.warn, "error");
            }
            this.creating = false;
          })
          .catch((error) => {
            console.error(error);
            //alert("No hubo conexión con el servidor");
            this.creating = false;
          });

          /* fetch('https://canplast.net:50000/api/v1/sap/POST/BusinessPartners',{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-access-token':localStorage.getItem('token-cpm')
            },
            body: JSON.stringify(jsonData)
          })
          .then((response) => response.json())
          .then((responseJson) => {
            console.log(responseJson)
            if(responseJson.CardCode){
              alert(responseJson.CardCode+' registrado correctamente ');
              firebase
              .firestore()
              .collection("NuevosClientes")
              .where("f_rfc", "==", this.f_rfc.toUpperCase())
              .get().then((querySnapshot) => {
                if (querySnapshot.size > 0) {
                  querySnapshot.forEach((doc) => {
                    firebase.firestore().collection("NuevosClientes").doc(doc.id).delete();
                  });
                }
              });
            }
            else{
              alert("Hubo un error: " + responseJson.warn)  
            }
            this.creating = false;
          })
          .catch((error) => {
            console.error(error);
            alert("No hubo conexión con el servidor");
            this.creating = false;
          }); */
        }, 2000);

      },
      checkSameAddress(){
        if(this.f_mismaDireccion){
          this.fe_calle = this.f_calle
          this.fe_noexterior = this.f_noexterior
          this.fe_nointerior = this.f_nointerior
          this.fe_codigopostal = this.f_codigopostal
          this.fe_estado = this.f_estado
          this.fe_municipio = this.f_municipio
          this.fe_colonia = this.f_colonia
          this.fe_pais = this.f_pais
          this.fe_titulo = 'Enviar a dirección fiscal'
        }
        // else{
        //   this.fe_calle = null
        //   this.fe_noexterior = null
        //   this.fe_nointerior = null
        //   this.fe_codigopostal = null
        //   this.fe_estado = 'ESTADO'
        //   this.fe_municipio = null
        //   this.fe_colonia = null
        //   this.fe_titulo = null
        // }
      }
    }
  };
</script>
<style></style>
